<template>
  <div>
    <ul class="type">
      <!-- 记薪方案列表 -->
      <li
        v-for="item in byTypeList"
        :key="item.payroll_sub_project_scheme_id"
        :class="{
          'type-item': true,
          'is-active': activeData.payroll_sub_project_scheme_id === item.payroll_sub_project_scheme_id
        }" >
        <span class="type-item-left" @click="handleRadio(item)">
          <el-radio :disabled="disEid" v-model="activeData.payroll_sub_project_scheme_id" :label="item.payroll_sub_project_scheme_id">{{ item.name }}</el-radio>
          <el-tag>{{ item.type_txt }}</el-tag>
        </span>
        <span class="type-item-right">
          <el-button type="text" @click="handleClick(item)">{{ $t('payroll_management_62') }}</el-button>
        </span>
      </li>
    </ul>
    <!-- 查看详情 -->
    <el-button class="add-item" icon="el-icon-plus" @click="handleAdd">{{ $t('1146') }}</el-button>
    <!-- 详情内容 -->
    <attendanceDetail ref="attendance" :projectSchemeId="activeData.payroll_sub_project_scheme_id"></attendanceDetail>
  </div>
</template>

<script>
import { getListByType, schemeToSubProject } from '@/api/payroll'
import attendanceDetail from './components/detail.vue'
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: { attendanceDetail },
  data() {
    return {
      byTypeList: []
    }
  },
  computed: {
    disEid() {
      // 计算失败、计算成功无法编辑
      return ['3', '4'].includes(this.activeData.info.calculate_state)
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() { // 获取记薪方案列表
      getListByType({ type: this.activeData.info.settlement_type || 1 }).then(res => {
        if (res && res.code === 1) this.byTypeList = res.data
      })
    },
    handleRadio(item) { // 选中记薪方案
      if (!this.disEid) this.activeData.payroll_sub_project_scheme_id = item.payroll_sub_project_scheme_id
    },
    handleClick(item) { //  查看详情
      this.$refs.attendance.init(item)
    },
    async saveData() { // 同步计薪方案 到 子项目
      const query = {
        sub_project_id: this.activeData.sub_project_id || this.$s.get('sub_project_id'),
        payroll_sub_project_scheme_id: this.activeData.payroll_sub_project_scheme_id
      }
      return await schemeToSubProject(query)
    },
    handleAdd() { // 添加记薪方案
      this.$emit('handleAdd')
    }
  }
}
</script>

<style lang="scss" scoped>
.type {
  &-item {
    height: 72px;
    line-height: 72px;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    margin-bottom: 24px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    &.is-active {
      border-color: #8AC8FF;
      background: #F6FBFF;
      .type-item-right {
        display: block;
      }
    }
    &-left {
      flex: 1;
      .el-tag {
        height: 22px;
        line-height: 20px;
        padding: 0 7px;
      }
      /deep/ .el-radio {
        margin-right: 16px;
        .el-radio__label {
          font-size: 16px;
          color: #262626;
        }
      }
    }
    &-right {
      display: none;
    }
    &:hover {
      border-color: #8AC8FF;
      .type-item-right {
        display: block;
      }
    }
  }
}
.add-item {
  width: 100%;
  height: 32px;
  display: block;
  border-style: dashed;
  // /deep/ .el-icon-plus {
  //   border: 1px dashed #D9D9D9;
  // }
}
</style>
